import React from 'react';
import CrmTimelineListPage from './components/CrmTimelineListPage';

export default function ActivitiesPage() {
  return (
    <CrmTimelineListPage
      pageKey="activitiesPage"
      showDealAmount
    />
  );
}
